import * as devisConf from '@/configuration/devisConf';

export default function miseAJourArticle(ligneCommande, tauxTvaDefault = null) {
  ligneCommande.typeRemise = devisConf.POURCENTAGE;
  ligneCommande.remise = 0;
  ligneCommande.tauxTva = tauxTvaDefault || 20;
  ligneCommande.uniteVente = devisConf.UNITE;
  ligneCommande.type = devisConf.NORMAL;
  ligneCommande.prixUnitaire = 0;
  ligneCommande.quantite = 1;
}



// WEBPACK FOOTER //
// ./src/services/devisCommandes/miseAJourArticle.js